(function () {
  'use strict';
  if (window.dkCroMeasurement) return;
  const sources = new Set(['main', 'sticky', 'quickadd']);
  const outcomes = new Set(['attempt', 'success', 'failure']);
  const pending = [];
  let timer = null;
  let retries = 0;
  const debug = new URLSearchParams(window.location.search).has('cro_qa');

  function log(event, status) {
    if (!debug) return;
    try {
      document.documentElement.dataset.dkCroLastEvent = event;
      document.documentElement.dataset.dkCroStatus = status;
    } catch (_) {}
    try { console.info('[DK CRO v2]', JSON.stringify({ event, status })); } catch (_) {}
  }

  function allowed() {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return !privacy || typeof privacy.analyticsProcessingAllowed !== 'function' ||
        privacy.analyticsProcessingAllowed() === true;
    } catch (_) { return false; }
  }

  function flush() {
    timer = null;
    if (!allowed()) {
      pending.splice(0).forEach((name) => log(name, 'consent-blocked'));
      return;
    }
    if (typeof window.clarity === 'function') {
      pending.splice(0).forEach((name) => {
        try {
          window.clarity('event', name);
          log(name, 'api-called');
        } catch (_) { log(name, 'api-error'); }
      });
      retries = 0;
    } else if (pending.length && retries++ < 30) {
      timer = setTimeout(flush, 1000);
    } else {
      pending.splice(0).forEach((name) => log(name, 'tracker-unavailable'));
    }
  }

  function emit(name) {
    if (!allowed()) { log(name, 'consent-blocked'); return; }
    if (pending.length >= 40) { log(name, 'queue-full'); return; }
    pending.push(name);
    log(name, 'queued');
    if (!timer) { retries = 0; flush(); }
  }

  window.dkCroMeasurement = Object.freeze({
    version: '2.0.0',
    track(outcome, source) {
      if (!sources.has(source) || !outcomes.has(outcome)) return;
      if (outcome === 'success') emit('dk_v2_atc_success');
      emit('dk_v2_atc_' + outcome + '_' + source);
    },
    stickyFormReturn() { emit('dk_v2_sticky_form_return'); }
  });
  if (debug) {
    try { document.documentElement.dataset.dkCroVersion = '2.0.0'; } catch (_) {}
    log('dk_v2_ready', 'ready');
  }
}());

